import Request from "@/libraries/request.js";
import Const from "@/const/const.js";

export default {
  BaseURL: "/report",
  async get(url = null) {
    const report = await Request.getAsync(url);
    let orders = [];
    if (report.data.status) {
      orders = report.data.data;
      for (const [keyOrder, valueOrder] of Object.entries(orders)) {
        if (valueOrder.items.length > 0) {
          for (const [keyItem, valueItem] of Object.entries(valueOrder.items)) {
            if (valueItem.unit) {
              orders[keyOrder].items[keyItem].unit_text =
                Const.product_unit[valueItem.unit];
            } else {
              orders[keyOrder].items[keyItem].unit_text =
                Const.product_unit[valueItem.unit_buy];
            }
          }
        }
      }
    }
    return orders;
  },
  async get_order(ordId = null) {
    const url =
      ordId != null
        ? this.BaseURL + "/order/" + ordId
        : this.BaseURL + "/order";
    const data = await this.get(url);
    if (data && data.length == 1 && ordId != null) {
      return data[0];
    } else {
      return data;
    }
  },
  async get_purchase_order_by_date_range(startDate, endDate) {
    const url =
      this.BaseURL +
      "/purchase_order/?startDate=" +
      startDate +
      "&endDate=" +
      endDate;
    const data = await this.get(url);
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/model/report_model.js